// vendor
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-loading-icon',
    styleUrls: ['./loading-icon.component.scss'],
    templateUrl: './loading-icon.component.html',
    standalone: false
})
export class LoadingIconComponent {
  public _theme = 'theme--light';
  public _size = 'size--lg';

  @Input()
  set theme(value: 'light' | 'dark') {
    this._theme = `theme--${value}`;
  }

  @Input()
  set size(value: 'xl' | 'lg' | 'md' | 'sm' | 'xs') {
    this._size = `size--${value}`;
  }

  @Input()
  svgAriaLabel: string = 'Loading...'

  @Input()
  styleExp?: object;
}
